export interface SkillCategory {
  category: string;
  items: string[];
}

export interface Experience {
  title: string;
  company: string;
  period: string;
  description: string;
}

export interface Education {
  degree: string;
  institution: string;
  period: string;
}

export interface Contact {
  email: string;
  github: string;
  linkedin: string;
  kaggle: string;
  whatsapp: string;
  facebook: string;
  instagram: string;
  twitter: string;
  reddit: string;
  youtube: string;
  stackoverflow: string;
  website: string;
  freelancer: string;
  upwork: string;
}

export const profile = {
  name: 'Atib Ur Rahmaan',
  title: 'AI Explorer & Code Alchemist',
  summary: 'A passionate full-stack developer, polymath, and tech enthusiast exploring cutting-edge innovations in Quantum Computing, AI, and Core Programming.',
  about: `I've been exploring technology since 2011, starting with cyber security and game development, and evolving into a full-stack developer and AI enthusiast. My journey spans from social engineering and game hacking to building enterprise applications and diving deep into machine learning.`,

  skills: [
    {
      category: 'Frontend Development',
      items: ['React', 'React Native', 'TypeScript', 'Next.js', 'Vue', 'Flutter', 'Ionic', 'SwiftUI', 'Kotlin UI']
    },
    {
      category: 'Backend Development',
      items: ['Node.js', 'Express', 'Flask', 'Django', 'Laravel', 'MongoDB', 'SQL']
    },
    {
      category: 'AI & Machine Learning',
      items: ['PyTorch', 'TensorFlow', 'Scikit-learn', 'Pandas', 'NumPy', 'OpenCV', 'NLTK', 'Hugging Face']
    },
    {
      category: 'Programming Languages',
      items: [
        'JavaScript', 'TypeScript', 'Java', 'CSS', 'HTML', 'PHP', 'Ruby',
        'Assembly', 'Python', 'Shell', 'C', 'SCSS', 'Kotlin', 'C++', 'Rust',
        'Dockerfile', 'Go', 'Clojure'
      ]
    },
    {
      category: 'Other Skills',
      items: ['Git', 'Docker', 'CI/CD', 'Blockchain', 'Web3', 'Quantum Computing', 'System Design']
    },
    {
      category: 'Hardware Development',
      items: ['Arduino', 'Raspberry Pi', 'ESP32', 'ESP8266', 'RISC-V', 'ARM']
    }
  ],

  experience: [
    {
      title: 'Full Stack Developer',
      company: 'Datarector',
      period: 'October 2025 - Present',
      description: 'Designing, developing, and maintaining full stack web applications using modern frontend and backend technologies. Collaborating with cross functional teams to translate business requirements into scalable technical solutions, optimizing performance, ensuring security best practices, and managing application deployments.'
    },
    {
      title: 'Full Stack Developer',
      company: 'Cyberclosys',
      period: 'March 2023 - Present',
      description: 'Building and maintaining end to end web applications, working on RESTful APIs, databases, and responsive user interfaces. Responsible for feature development, debugging, performance optimization, and integrating third party services while following clean code and version control practices.'
    },
    {
      title: 'SAP ABAP Developer',
      company: 'TMC (TallyMarks Consulting)',
      period: 'December 2022 - June 2023',
      description: 'Developed and maintained SAP ABAP applications.'
    },
    {
      title: 'Java Developer',
      company: 'Emeriosoft',
      period: 'March 2022 - July 2022',
      description: 'Worked on various Java-based assignments and projects.'
    },
    {
      title: 'Manager',
      company: 'Meme Ad',
      period: 'January 2022 - Present',
      description: 'Leading the first meme marketing company in Pakistan, executing innovative campaigns and creating opportunities for students.'
    },
    {
      title: 'Campaign Manager',
      company: 'Mememarketing.pk',
      period: 'July 2019 - Present',
      description: 'Managing social media campaigns and optimizing content performance through algorithmic analysis.'
    },

  ],

  education: [
    {
      degree: 'Computer Science',
      institution: 'Iqra University',
      period: '2020 - 2024'
    },
    {
      degree: 'HSC, Pre-Engineering',
      institution: 'Bahria College',
      period: '2016 - 2018'
    },
    {
      degree: 'SSC, Biology',
      institution: 'Bahria College',
      period: '2014 - 2016'
    }
  ],

  contact: {
    email: 'ateebnoone@gmail.com', // Updated to match your provided email
    github: 'https://github.com/AteebNoOne',
    linkedin: 'https://www.linkedin.com/in/ateebnoone',
    kaggle: 'https://www.kaggle.com/ateebnoone',
    whatsapp: '+923182553930',
    facebook: 'https://www.facebook.com/neverwastemoney',
    instagram: 'https://www.instagram.com/ateebnoone',
    twitter: 'https://x.com/AteebNoOne',
    reddit: 'https://www.reddit.com/user/AteebNoOne/',
    youtube: 'https://www.youtube.com/@AteebNoOne',
    stackoverflow: 'https://stackoverflow.com/users/19037482/atib-ur-rehman',
    website: 'https://ateebnoone.vercel.app/',
    freelancer: 'https://www.freelancer.pk/u/AteebNoOne',
    upwork: 'https://www.upwork.com/freelancers/~017c8ed8ae3e2ff7c0'
  }
};